import { Accordion, AccordionDetails, AccordionSummary, styled, SxProps, useTheme } from "@mui/material";
import { themeSettings } from "../../../configuration/themeSettings";

export const AccordionNoteStyled = styled(Accordion, {
    label: "OrderOffer-AccordionNoteStyled",
})(({ theme }) => ({
    root: {
        border: "0px solid rgba(0, 0, 0, 0)",
        boxShadow: "none",
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: 0,
            padding: 0,
        },
    },
    expanded: {},
}));

export const AccordionSummaryNoteStyled = styled(AccordionSummary, {
    label: "OrderOffer-AccordionSummaryNoteStyled",
})(({ theme }) => ({
    root: {
        border: "0px solid rgba(0, 0, 0, 0)",
        boxShadow: "none",
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: 0,
            padding: 0,
        },
    },
    expanded: {},
}));

export const AccordionDetailsNoteStyled = styled(AccordionDetails, {
    label: "OrderOffer-TypographyPonTitleStyled",
})(({ theme }) => ({
    root: {
        padding: 0,
    },
}));
;

export const useClasses = () => {
    const theme = useTheme();
    const classes = {
        titleComment: {
            transform: "translate(13px, -9px) !important",
        } as SxProps,

        multiline: {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.grey,
                borderWidth: "1px",
            },
          
            "& .MuiInputBase-multiline ": {
                margin: "0px", // Adjust the margin of the text inside the multiline TextField
                padding: "5px",
                color: themeSettings.main.palette.primary.main,
                fontFamily: themeSettings.main.typography.fontFamily,
                fontSize:"12px",
                width: '50%',
            },
        } as SxProps,

        inputMultiline: {
            color: theme.palette.grey,
        } as SxProps,
    };
    return classes;
};

/*const Accordion = withStyles({
  
})(MuiAccordion);

const AccordionSummary = withStyles({
 
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: 0,
  },
}))(MuiAccordionDetails);

const useStyles = makeStyles({
  
});
*/